import type { FetchReactionDataForMessageListActionMessage } from './actions/fetchReactionDataForMessageList';
import type { TableView } from 'owa-mail-list-store';
import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "ReactionsInMessageList" */ './lazyIndex'),
    { name: 'ReactionsInMessageList' }
);

export const lazyFetchReactionDataForMessageList: LazyAction<
    (tableView: TableView, targetRowKeys: string[]) => FetchReactionDataForMessageListActionMessage,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.fetchReactionDataForMessageList);
